import { locales } from './locales'

export const languages = [
  {
    value: locales[0],
    label: 'English',
  },
  {
    value: locales[1],
    label: 'Português',
  },
  {
    value: locales[2],
    label: 'Español',
  },
  {
    value: locales[3],
    label: '中国人',
  },
  {
    value: locales[4],
    label: '日本語',
  },
  {
    value: locales[5],
    label: 'Français',
  },
  {
    value: locales[6],
    label: 'Deutsch',
  },
  {
    value: locales[7],
    label: 'Pусский',
  },
  {
    value: locales[8],
    label: 'Indonesian',
  },
  {
    value: locales[9],
    label: 'हिन्दी',
  },
  {
    value: locales[10],
    label: '한국어',
  },
  {
    value: locales[11],
    label: 'Polski',
  },
  {
    value: locales[12],
    label: 'Türkçe',
  },
  {
    value: locales[13],
    label: 'Tiếng Việt',
  },
  {
    value: locales[14],
    label: 'Suomen',
  },
  {
    value: locales[15],
    label: 'اَلْعَرَبِيَّةُ',
  },
]
